import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import {
  Snackbar,
  SnackbarContent,
} from '@material-ui/core/';
import ErrorIcon from '@material-ui/icons/Error';
const variantIconError = {
  error: ErrorIcon,
};
const useStyleError = makeStyles(theme => ({
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
  },
}));
export default function SnackbarContentError(props) {
  const classes = useStyleError();
  const { className, message, onClose, variant, ...other } = props;
  const Icon = variantIconError[variant];
  const [state] = React.useState({
    open: true,
    vertical: 'bottom',
    horizontal: 'center',
  });
  const { vertical, horizontal, open } = state;
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom', // fixed issues blocking the screen
        horizontal: 'center',
      }}
      open={open}
      className={clsx(classes[variant], className)}
      key={`${vertical},${horizontal}`}
      >
      <SnackbarContent
                                                                                  // worked 
                                                                                  // className={clsx(classes[variant], className)}
        style={{
                                                                                  // backgroundColor:'#00ff00',
          backgroundColor:'red',
        }}
        aria-describedby="snackbar-error"
        message={
          <span 
            id="snackbar-error" 
            className={classes.message}
          >
            <Icon className={clsx(classes.icon, classes.iconVariant)} />
            {props.message}
          </span>
        }
        {...other}
      />
    </Snackbar>
  );
}
SnackbarContentError.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['error']).isRequired,
};